import { __decorate } from "tslib";
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
let DialogServiceImpl = class DialogServiceImpl {
    constructor() {
        this.el = null;
        this.app = null;
    }
    init(app) {
        this.el = app.$el;
        this.app = app;
        return this;
    }
    show() {
        document.body.appendChild(this.el);
    }
    close() {
        if (this.app) {
            this.app.$destroy();
            this.app = null;
        }
        if (this.el) {
            if (document.body.contains(this.el)) {
                document.body.removeChild(this.el);
            }
            this.el = null;
        }
    }
};
DialogServiceImpl = __decorate([
    injectable()
], DialogServiceImpl);
export { DialogServiceImpl };
